module.exports = __webpack_public_path__ + "068d6c606dd4ad245d64037e6170e30c.png";